<template>
  <el-tabs v-model="activeName" v-loading="loading" tab-position="left" style="min-height: 300px">
    <el-tab-pane v-for="(list, label) in postOfficesGrouped" :label="label" :name="label" :key="label">
      <div class="row no-gutters g-mx-minus-10">
        <div class="col-sm-4 col-lg-3 g-px-10 g-mb-20"  v-for="po in list" :key="po.id">
          <div
            class="u-block-hover g-brd-around g-brd-gray-light-v4 g-color-black
             text-center rounded g-transition-0_3 g-px-30 g-py-50 h-100"
          >
            <h5 class="g-font-weight-600 mb-0">{{ po.name }}</h5>
            <span class="g-font-size-12 text-uppercase text-muted">{{ po.address }}</span>
            <br>
            <span class="g-font-size-12 text-uppercase text-muted">{{ po.remark }}</span>
          </div>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { Probability, showErrorMessage } from '@/helpers';

export default {
  name: 'PostOfficesList',
  mounted() {
    (new Probability({
      p: this.postOffices.length ? '50%' : '100%',
      f: () => this.getPostOffices(),
    }))();
    // eslint-disable-next-line
    this.activeName = this.postOfficeDistricts[0];
  },
  data() {
    return {
      loading: false,
      activeName: '',
    };
  },
  computed: {
    ...mapState({
      postOffices: state => state.postOffices,
      postOfficesGrouped: state => state.postOfficesGrouped,
    }),
    ...mapGetters(['postOfficeDistricts']),
  },
  methods: {
    getPostOffices() {
      this.loading = true;
      this.$store.dispatch('fetchPostOffices').then(() => {
        // eslint-disable-next-line
        this.activeName = this.postOfficeDistricts[0];
      }).catch((e) => {
        showErrorMessage(e);
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss">

</style>
